module.exports = __webpack_public_path__ + "static/elixirsthumb-026e7ad611d4f26f24ea3b60a9b6acd8.jpg";